import React from 'react';

// eslint-disable-next-line lodash/import-scope
import { find } from 'lodash';
import { connect } from 'react-redux';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import buildCityString from '../../lib/buildCityStateString';
import getTaxonomy from '../../lib/page-taxonomy';

import CLResults from './cl-results';
import type { CLResultsProps } from './cl-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () =>
    `${appConfigs.SITE_BASE_URL}/cost-of-living-calculator/city-life/CITY`,
  metadataOptions: (props) => {
    const citySlug = props?.params?.citySlug;
    const cityData = find(props?.cities, { slug: citySlug });
    const cityState = buildCityString(cityData);
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('cl') },
      variables: { cityState },
      url: (url) => (url ? url.replace('CITY', citySlug) : url),
      driverPageName: 'mortgages_city_life',
    };
  },
};
const CLResultsWrapper = (props: CLResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={CLResults}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    cities: state?.cityLife?.cities,
  };
};

export default connect(mapStateToProps)(CLResultsWrapper);
